import { call, put, takeEvery } from "redux-saga/effects";
import {
  getCampaignDirectionTypesList,
  hideCampaignDirectionTypesListLoader,
  setCampaignDirectionTypeProfile,
  setCampaignDirectionTypesList,
  setErrorCampaignDirectionTypeProfile,
  showCampaignDirectionTypesListLoader
} from "./actions";
import {
  ADD_CAMPAIGN_DIRECTION_TYPES,
  DELETE_CAMPAIGN_DIRECTION_TYPES,
  GET_CAMPAIGN_DIRECTION_TYPE_PROFILE,
  GET_CAMPAIGN_DIRECTION_TYPES_LIST,
  UPDATE_CAMPAIGN_DIRECTION_TYPE_PROFILE
} from "./actionTypes";
import {
  deleteCampaignDirectionType,
  getCampaignDirectionType,
  getCampaignDirectionTypeProfile,
  postCampaignDirectionType,
  putCampaignDirectionTypeProfile
} from "../../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../../helpers/utils";

// Chat Redux States
function* onGetCampaignDirectionTypeList({ payload: data }) {
  try {
    yield put(showCampaignDirectionTypesListLoader());
    let response = yield call(getCampaignDirectionType, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({ ...i, description: i.description === "string" ? "" : i.description }))
    };
    yield put(setCampaignDirectionTypesList(response));
    yield put(hideCampaignDirectionTypesListLoader());
  } catch (error) {
    yield put(hideCampaignDirectionTypesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCampaignDirectionType({ payload: {directionType, data } }) {
  try {
    yield put(showCampaignDirectionTypesListLoader());
    yield call(postCampaignDirectionType, {
      name: directionType.name,
      description: directionType.description
    });
    yield call(onGetCampaignDirectionTypeList, { payload: data });
    yield put(hideCampaignDirectionTypesListLoader());
    showSuccessMessage("Campaign's direction type has been added");
  } catch (error) {
    yield put(hideCampaignDirectionTypesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteDirectionType({ payload: { id, data } }) {
  try {
    yield put(showCampaignDirectionTypesListLoader());
    yield call(deleteCampaignDirectionType, id);
    yield call(onGetCampaignDirectionTypeList, { payload: data });
    yield put(hideCampaignDirectionTypesListLoader());
    showSuccessMessage("Campaign direction type has been deleted");
  } catch (error) {
    yield put(hideCampaignDirectionTypesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignDirectionTypeProfile({ payload: id }) {
  try {
    yield put(setErrorCampaignDirectionTypeProfile(false));
    let response = yield call(getCampaignDirectionTypeProfile, id);
    yield put(setCampaignDirectionTypeProfile(response));
  } catch (error) {
    if (getErrorMessage(error) === 'Not found.') {
      yield put(setErrorCampaignDirectionTypeProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onUpdateCampaignDirectionTypeProfile({ payload: {id, directionType, data } }) {
  try {
    yield put(showCampaignDirectionTypesListLoader());
    yield call(putCampaignDirectionTypeProfile, id, {
      name: directionType.name,
      description: directionType.description
    });
    yield call(onGetCampaignDirectionTypeList, { payload: data });;
    yield put(hideCampaignDirectionTypesListLoader());
    showSuccessMessage("Campaign direction type has been updated");
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignDirectionTypeListSaga() {
  yield takeEvery(GET_CAMPAIGN_DIRECTION_TYPES_LIST, onGetCampaignDirectionTypeList);
  yield takeEvery(DELETE_CAMPAIGN_DIRECTION_TYPES, onDeleteDirectionType);
  yield takeEvery(ADD_CAMPAIGN_DIRECTION_TYPES, onAddCampaignDirectionType);
  yield takeEvery(GET_CAMPAIGN_DIRECTION_TYPE_PROFILE, onGetCampaignDirectionTypeProfile);
  yield takeEvery(UPDATE_CAMPAIGN_DIRECTION_TYPE_PROFILE, onUpdateCampaignDirectionTypeProfile);
}

export default campaignDirectionTypeListSaga;
